import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { POPS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getPopAction = createAsyncThunk(
    'pop/getPopAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ POPS_PATH }/${ data.id }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getPopSlice = createSlice({
    name: 'getPopSlice',
    initialState: DEFAULT_STATE,
    reducers: {
        invalidatePod() {
            return DEFAULT_STATE;
        }
    },
    extraReducers: builder => {
        builder.addCase(getPopAction.pending, () => STATE__API__STARTED);
        builder.addCase(getPopAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getPopAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const { invalidatePod } = getPopSlice.actions;
export const getPopState = (state) => state.pop.getPop;
export default getPopSlice.reducer;
